import React from "react";

/**
 * Log Browser Icon Component
 * @description A document icon with lines representing log entries
 */
export const LogBrowserIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
      fill="white"
    />
    <path d="M14 2v6h6" fill="white" />
    <path d="M16 13H8" stroke="#1a1a1a" strokeWidth="1.5" />
    <path d="M16 17H8" stroke="#1a1a1a" strokeWidth="1.5" />
    <path d="M10 9H8" stroke="#1a1a1a" strokeWidth="1.5" />
  </svg>
);

export default LogBrowserIcon;

